module.exports = __webpack_public_path__ + "static/img/ket-renewal-pc-sub-page-01@w.15c68f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-pc-sub-page-01@w.png
// module id = SrTi
// module chunks = 0